import { DateTime, Duration } from 'luxon';

export const duration = (seconds: number) => {
  return Duration.fromObject({ seconds }).toFormat('hh:mm:ss');
};

export const formatTime = (iso8601: string) => {
  return DateTime.fromISO(iso8601).toFormat('HH:mm');
};

const time = {
  duration,
  formatTime,
};

export default time;
